import React from 'react';

import { Pricing } from '../../../../types';
import CampaignContactForm from '../../../Campaign/CampaignContactForm';
import ContactFormTypography from '../../../ContactForm/ContactFormTypography';
import Divider from '../../../ContactForm/Divider';
import Grow from '../../../ContactForm/FormValues/Grow';
import ImageWrapper from '../../../ContactForm/FormValues/ImageWrapper';
import StraightenIcon from '../../../ContactForm/FormValues/StraightenIcon';
import StyledContent from '../../../ContactForm/FormValues/StyledContent';
import StyledWrapper from '../../../ContactForm/FormValues/StyledWrapper';
import Wrapper from '../../../ContactForm/FormValues/Wrapper';
import Row from '../../../ContactForm/Row';
import Price from '../../../Price';
import StyledFromDiscount from '../../Price/StyledFromDiscount';
import StyledPriceContent from '../../Price/StyledPriceContent';
import StyledStrikeThroughPrice from '../../Price/StyledStrikeThroughPrice';
import { PageBaseProps } from '../../types';

export type FormHeaderProps = Pick<
  PageBaseProps,
  | 'principalCurrency'
  | 'pricing'
  | 'secondaryCurrency'
  | 'surface'
  | 'surfaceUnit'
> & {
  campaignChipText?: string;
  campaignPricing?: Pricing;
  companyLogo?: string;
};

const FormHeader: React.FC<FormHeaderProps> = ({
  campaignChipText,
  campaignPricing,
  companyLogo,
  pricing,
  principalCurrency,
  secondaryCurrency,
  surface,
  surfaceUnit,
  ...rest
}) => {
  return (
    <React.Fragment>
      <Wrapper {...rest}>
        <StyledWrapper>
          {companyLogo && <ImageWrapper src={companyLogo}></ImageWrapper>}
          <StyledContent>
            {campaignPricing ? (
              <Price
                FromDiscountsComponent={StyledFromDiscount}
                PriceDiscountComponent={StyledPriceContent}
                StrikeThroughPriceComponent={StyledStrikeThroughPrice}
                currency={principalCurrency}
                originalPricing={pricing}
                pricing={campaignPricing}
              />
            ) : (
              <React.Fragment>
                {' '}
                <Row>
                  <div>
                    <ContactFormTypography
                      variant='text'
                      weight='regular'
                      color='midnightBlue'
                    >
                      Desde
                    </ContactFormTypography>
                  </div>
                </Row>
                <Row>
                  <div>
                    <ContactFormTypography
                      variant='jumbo'
                      weight='medium'
                    >
                      {pricing[principalCurrency]}
                    </ContactFormTypography>
                  </div>
                </Row>
                {pricing[secondaryCurrency] && (
                  <Row>
                    <div>
                      <ContactFormTypography
                        variant='text'
                        color='blackCoral'
                        weight='regular'
                      >
                        {pricing[secondaryCurrency]}
                      </ContactFormTypography>
                    </div>
                  </Row>
                )}
              </React.Fragment>
            )}
          </StyledContent>
        </StyledWrapper>
        <Row>
          {campaignChipText ? (
            <CampaignContactForm
              surface={surface}
              surfaceUnit={surfaceUnit}
              campaignChipText={campaignChipText}
            />
          ) : (
            <React.Fragment>
              <Grow>
                <ContactFormTypography
                  variant='text'
                  align='left'
                  color='blackCoral'
                  weight='light'
                >
                  <StraightenIcon /> Desde{' '}
                  {surface.toLocaleString(process.env.NEXT_PUBLIC_LANGUAGE)}{' '}
                  {surfaceUnit}
                </ContactFormTypography>
              </Grow>
            </React.Fragment>
          )}
        </Row>
      </Wrapper>
      <Divider />
    </React.Fragment>
  );
};

export default FormHeader;
